import { useState } from 'react';
import generatePassword from 'secure-password-gen';
import IPasswordFieldProps from './IPasswordFieldProps';
import { Col, Row } from 'react-grid-system';
import TextField from '../../../../components/formFields/textField/TextField';
import { Button } from '@fluentui/react-components';
import { EyeFilled, EyeOffFilled, KeyFilled } from '@fluentui/react-icons';
import styles from './PasswordField.module.scss';
import PasswordStrengthIndicator from './strengthIndicator/StrengthIndicator';
import { useTranslation } from 'react-i18next';

const PasswordField = (props: IPasswordFieldProps) => {
  const { t } = useTranslation();

  const [showPassword, setShowPassword] = useState<boolean>(false);

  const toggleShowPassword = () => setShowPassword(prev => !prev);

  const handlePasswordChange = (value: string) => props.onChange('password', value);

  const handleGeneratePassword = () => {
    const newPassword = generatePassword();
    props.onChange('password', newPassword);
  };

  return (
    <Row align="center" gutterWidth={2}>
      <Col className={styles.passwordFieldCol}>
        <TextField required
          type={showPassword ? 'text' : 'password'}
          label={t("passwords.form.fields.password.label")}
          value={props.password}
          onChange={handlePasswordChange}
          placeholder={t("passwords.form.fields.password.placeholder")}
          />
        <PasswordStrengthIndicator password={props.password} />
      </Col>
      <Col xs="content">
        <Button
          type="button"
          icon={<KeyFilled />}
          onClick={handleGeneratePassword}
          className={styles.btnGeneratePassword}
          />
        <Button
          type="button"
          icon={showPassword ? <EyeOffFilled /> : <EyeFilled />}
          onClick={toggleShowPassword}
          className={styles.btnToggleVisibility}
          />
      </Col>
    </Row>
  );
};

export default PasswordField;